var events = [];
export var registerEvent = function registerEvent(event) {
  events.push(event);
};

/**
 * Take all events registered so far, return them, and clear the list.
 */
export var drainEvents = function drainEvents() {
  return events.splice(0, events.length);
};